import { jsx as _jsx } from "react/jsx-runtime";
import LottieView from "react-native-web-lottie";
const LottieAnimation = ({ autoPlay = true, loop = true, source, style }) => {
    return _jsx(LottieView, { source: source, style: style, autoPlay: autoPlay, loop: loop });
};
export default LottieAnimation;
